import type { ButtonHTMLAttributes } from 'react';

export function Button({ variant = 'secondary', size, block, className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'ghost' | 'danger'; size?: 'lg'; block?: boolean }) {
  return <button type="button" className={`lm-btn lm-btn-${variant} ${size === 'lg' ? 'lm-btn-lg' : ''} ${block ? 'lm-btn-block' : ''} ${className ?? ''}`} {...rest} />;
}

export function IconButton({ className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" className={`lm-icon-btn ${className ?? ''}`} {...rest} />;
}

export function Switch({ checked, onChange, label, testId }: { checked: boolean; onChange: (v: boolean) => void; label?: string; testId?: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className="lm-switch"
      data-testid={testId}
      onClick={(e) => {
        e.stopPropagation();
        onChange(!checked);
      }}
    />
  );
}
